import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7e21aac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "customer-list-wrapper p-5"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid grid-nogutter" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, "顧客詳細"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-red" }, "顧客の紐付けができていないユーザーです")
  ])
], -1))
const _hoisted_3 = { class: "grid grid-nogutter" }
const _hoisted_4 = { class: "p-inputgroup flex-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-list-wrapper grid grid-nogutter" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-6 list-header" }, "カルテNo."),
  /*#__PURE__*/_createElementVNode("div", { class: "col-6 list-header" }, "名前")
], -1))
const _hoisted_6 = { class: "customer-list-content grid grid-nogutter" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "col text-center empty-result"
}

import { ref, computed } from "vue";
import { CustomerServices } from "@/clinic/services";
import { ICustomer } from "@/clinic/typings";
import CustomerDetail from "../CustomerDetail/index.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    clinicId: null,
    accountId: null,
    customers: null,
    tags: null
  },
  setup(__props: any) {

const props = __props as {
  clinicId: number;
  accountId: number;
  customers: any;
  tags: any;
};

const customer = ref<ICustomer>({});
const customers = ref<ICustomer[]>([]);
const term = ref<string>("");
const customerId = ref(0);
const showDetailFlag = ref(false);


const customersFiltered = computed(() => {
  return props.customers.filter((customer: any) => {
    return (
      customer.name.toLowerCase().includes(term.value.toLowerCase()) ||
      (customer.code || "").toString().includes(term.value)
    );
  });
});

const showDetail = (id: number) => {
  customer.value = props.customers.find((customer: any) => customer.id == id);
  customerId.value = id;
  showDetailFlag.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showDetailFlag.value)
      ? (_openBlock(), _createBlock(CustomerDetail, {
          key: 0,
          "clinic-id": props.clinicId,
          "customer-id": customerId.value,
          "account-id": props.accountId,
          customer: customer.value,
          "link-customer": true,
          tags: props.tags
        }, null, 8, ["clinic-id", "customer-id", "account-id", "customer", "tags"]))
      : _createCommentVNode("", true),
    (!showDetailFlag.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Button, {
                icon: "pi pi-search",
                class: "show-search-icon"
              }),
              _createVNode(_component_InputText, {
                modelValue: term.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((term).value = $event)),
                class: "form-search-input",
                placeholder: "カルテNo.、お名前"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (_unref(customersFiltered).length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(customersFiltered), (customer, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createElementVNode("div", {
                      class: "col-6 customer-id cursor-pointer",
                      onClick: ($event: any) => (showDetail(customer.id))
                    }, _toDisplayString(customer.code), 9, _hoisted_7),
                    _createElementVNode("div", {
                      class: "col-6 customer-name cursor-pointer",
                      onClick: ($event: any) => (showDetail(customer.id))
                    }, _toDisplayString(customer.name), 9, _hoisted_8)
                  ], 64))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, "データがありません"))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})